<script lang="ts">
import { defineComponent, ref } from 'vue'
import TemplateSolutionFormLp from '@/components/_core/TemplateSolutionFormLp.vue'
import VideoMain from './Main.vue'
import VideoBreadcrumb from './Breadcrumb.vue'
import type { Ref } from 'vue'

export default defineComponent({
  name: 'VideoApp',

  components: {
    TemplateSolutionFormLp,
    VideoMain,
    VideoBreadcrumb,
  },

  setup() {
    const logoColor: Ref<'default' | 'white' | 'gray'> = ref('default')

    return {
      // data
      logoColor,
    }
  }
})
</script>

<template>
  <TemplateSolutionFormLp :logo-color="logoColor">
    <template #breadcrumbHeader>
      <VideoBreadcrumb />
    </template>

    <template #main>
      <VideoMain @init:logo-color="logoColor = $event" />
    </template>
  </TemplateSolutionFormLp>
</template>
